export { Selects } from './js/selects'

export function FormInit() {
    const formEls = document.querySelectorAll('.js-form')
    const forms = Array.from(formEls)
    if (forms.length) {
        import('./js/controller')
            .then((m) => m.FormController)
            .then((FormController) => {
                forms.forEach((el) => {
                    FormController(el)
                    HoverLabelInit(el)
                    SearchInputInit(el)
                })
            })
    }
}

export function HoverLabelInit(context = document) {
    let inputEls = context.querySelectorAll('.js-hover-label')
    if (inputEls.length) {
        import('./js/hover-label')
            .then((m) => m.HoverLabel)
            .then((HoverLabel) => {
                HoverLabel(inputEls)
            })
    }
}

export function SearchInputInit(context = document) {
    let searchEls = context.querySelectorAll('.js-search-input')
    if (searchEls.length) {
        import('./js/search-input')
            .then((m) => m.SearchInput)
            .then((SearchInput) => {
                SearchInput(searchEls, context)
            })
    }
}
